import { t } from "i18next";
import React from "react";

import { TextAlignType } from "../../../interfaces/types";

import { AlignTextCenter } from "../../shared/Icons/AlignTextCenter";
import { AlignTextLeft } from "../../shared/Icons/AlignTextLeft";
import { AlignTextRight } from "../../shared/Icons/AlignTextRight";
import Typography from "../../shared/typography/Typography";
import { IOption, SelectIcons } from "../SelectIcons";

import { Actions, Container, IconContainer} from "./styles";

interface IProps {
  textAlign: TextAlignType;
  setTextAlign: React.Dispatch<TextAlignType>;
  menuDisplayMode?: boolean;
  style?: React.CSSProperties;
}

const optionsTextAlign: IOption[] = [
  {value: 'left', icon: <AlignTextLeft />},
  {value: 'center', icon: <AlignTextCenter />},
  {value: 'right', icon: <AlignTextRight />},
];

export const TextActions = ({setTextAlign, textAlign, menuDisplayMode=false, style}: IProps) => {
  return (
    <Container style={style}>
      <Actions menuDisplayMode={menuDisplayMode} >
        <Typography className="title" type="paragraphXXS" color="title">{t("paragraph")}</Typography>

        { menuDisplayMode ? (
          <SelectIcons options={optionsTextAlign} selected={textAlign} setSelected={setTextAlign}  />
        ) : (
          optionsTextAlign.map( option => (
            <IconContainer
              key={option.value}
              onClick={() => setTextAlign(option.value as TextAlignType)} 
              active={textAlign === option.value}
            >
              {option.icon}
            </IconContainer>
          ))
        )}
      </Actions>
    </Container>
  );
}